<template>
    <div class="page-wrapper page-wrapper--plans" data-testid="plans-view">
      <!-- <div class="h-[389px] w-full bg-white flex-col justify-start items-start overflow-hidden relative hidden md:inline-flex" data-testid="hero-section-desktop">
        <div class="h-[389px] flex-col justify-start items-end gap-2 flex absolute left-0 bg-hero-image">
        </div>
        <div class="flex justify-center w-full">
          <div class="h-[172px] flex-col justify-start items-start gap-6 inline-flex z-2 mt-[88px] max-w-[1440px] px-[40px] w-full">
            <div class="w-[410px] text-[#52B4FF] text-4xl font-['Inter'] leading-[44px] font-semibold tracking-tight" data-testid="hero-title">{{ $t('plans_find_the_right_plan') }}</div>
            <div class="w-[375px] text-white/90 text-[19px] font-['Inter'] leading-[30px]">{{ $t('plans_v0_subheader') }}</div>
          </div>
        </div>
      </div>
      <div className="h-[358px] relative inline-flex flex-col justify-start items-start md:hidden bg-[#056770] w-full px-[24px] py-[40px]" data-testid="hero-section-mobile">
        <div className="w-[327px] h-[278px] flex flex-col justify-start items-start gap-6">
          <div className="relative justify-start text-white text-4xl font-['Inter'] leading-[44px] tracking-tight font-semibold" data-testid="hero-title-mobile">{{ $t('plans_find_the_right_plan') }}</div>
          <div className="h-[122px] flex flex-col justify-start items-start gap-2">
            <div className="relative justify-start text-white/90 text-[19px] font-['Inter'] leading-[30px]">{{ $t('plans_with_ai_powered') }}</div>
            <div className="relative justify-start text-white/90 text-base font-medium font-['Inter'] leading-normal" data-testid="view-plans-link" @click="scrollToPricingCards">{{ $t('plans_view_plans') }} ></div>
          </div>
        </div>
      </div> -->
      <div class="flex-col justify-start items-start gap-16 inline-flex max-w-[1440px] pt-[40px] md:pt-[46px] px-[24px] md:px-[40px] pb-[73px] w-full h-full md:h-auto" data-testid="pricing-section">
        <div class="self-stretch flex-col justify-start items-start flex">
          <div class="text-white text-[36px] font-semibold font-['Inter'] leading-[44px]" data-testid="pricing-plans-title">{{ $t('plans_pricing_plans') }}</div>
          <div class="self-stretch max-w-[1000px] justify-between items-center inline-flex mt-[24px]">
            <div class="grow shrink basis-0 text-white/75 text-[19px] font-medium font-['Inter'] leading-[30px]" data-testid="flexible-options-text">{{ $t('plans_flexible_options') }}</div>
          </div>
          <div class="w-full mt-[32px]">
            <div class="text-white/90" data-testid="all-plans-include">
              {{ $t('plans_all_plans_include') }}
            </div>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mt-[16px]" data-testid="features-grid">
              <div class="flex flex-col gap-4" data-testid="features-column-1">
                <div class="flex items-start gap-2">
                  <img src="@/assets/icons/sorenson/check.svg" alt="check" />
                  <div class="text-white/90 text-sm font-medium font-['Inter'] leading-tight">{{ $tr('plans_v0_attribute_1') }}</div>
                </div>
                <div class="flex items-start gap-2">
                  <img src="@/assets/icons/sorenson/check.svg" alt="check" />
                  <div class="text-white/90 text-sm font-medium font-['Inter'] leading-tight">{{ $t('plans_v0_attribute_2') }}</div>
                </div>
                <div class="flex items-start gap-2">
                  <img src="@/assets/icons/sorenson/check.svg" alt="check" />
                  <div class="text-white/90 text-sm font-medium font-['Inter'] leading-tight">{{ $t('plans_v0_attribute_3') }}</div>
                </div>
              </div>
              <div class="flex flex-col gap-4" data-testid="features-column-2">
                <div class="flex items-start gap-2">
                  <img src="@/assets/icons/sorenson/check.svg" alt="check" />
                  <div class="text-white/90 text-sm font-medium font-['Inter'] leading-tight">{{ $t('plans_v0_attribute_4') }}</div>
                </div>
                <div class="flex items-start gap-2">
                  <img src="@/assets/icons/sorenson/check.svg" alt="check" />
                  <div class="text-white/90 text-sm font-medium font-['Inter'] leading-tight">{{ $t('plans_v0_attribute_5') }}</div>
                </div>
                <div class="flex items-start gap-2">
                  <img src="@/assets/icons/sorenson/check.svg" alt="check" />
                  <div class="text-white/90 text-sm font-medium font-['Inter'] leading-tight">{{ $t('plans_v0_attribute_7') }}</div>
                </div>
              </div>
              <div class="flex flex-col gap-4" data-testid="features-column-3">
                <div class="flex items-start gap-2">
                  <img src="@/assets/icons/sorenson/check.svg" alt="check" />
                  <div class="text-white/90 text-sm font-medium font-['Inter'] leading-tight">{{ $t('plans_v0_attribute_8') }}</div>
                </div>
                <div class="flex items-start gap-2">
                  <img src="@/assets/icons/sorenson/check.svg" alt="check" />
                  <div class="text-white/90 text-sm font-medium font-['Inter'] leading-tight">{{ $t('plans_v0_attribute_6') }}</div>
                </div>
                <div class="flex items-start gap-2">
                  <img src="@/assets/icons/sorenson/check.svg" alt="check" />
                  <div class="text-white/90 text-sm font-medium font-['Inter'] leading-tight">{{ $t('plans_v0_attribute_10') }}</div>
                </div>
              </div>
            </div>
          </div>
          <div
            id="pricing-cards"
            class="h-fit gap-6 w-full mt-[40px] grid grid-cols-1 md:grid-cols-2 items-stretch"
            :class="pricingCardsGridClass"
            data-testid="pricing-cards-container"
          >
            <template v-if="isFetching">
              <PricingCard
                v-for="i in 3"
                v-bind:key="i"
                is-loading
                :data-testid="`loading-card-${i}`"
              >
              </PricingCard>
            </template>
            <!-- {{ displayProductsModified }} -->
            <PricingCard
              v-for="plan in displayProductsModified"
              :key="plan.id"
              :title="getPlanTitle(plan)"
              :description="plan.description || ''"
              :button-text="getPlanButtonText(plan)"
              :disabled="isPlanButtonDisabled(plan)"
              @click="() => selectPlan(plan)"
              :current="isCurrentPlan(plan)"
              :recommended="plan.is_recommended && !isEnterpriseUser"
              :price-text="getPriceText(plan)"
              :show-price="showPrices"
              :discount-from-text="getDiscountFromText(plan)"
              :data-testid="`pricing-card-${plan.id}`"
            >
              <template #features>
                <div class="h-24 flex-col justify-start items-start gap-4 inline-flex">
                  <div
                    v-for="feature in getPlanFeatureItems(plan)"
                    :key="feature.key"
                    class="self-stretch justify-start items-start gap-2 inline-flex"
                  >
                    <img :src="feature.icon" :alt="feature.iconAlt" />
                    <div class="grow shrink basis-0 text-white/75 text-sm font-medium font-['Inter'] leading-tight">{{ feature.text }}</div>
                  </div>
                  <div class="justify-start items-center gap-2.5 inline-flex" v-if="plan.billing?.type === BillingType.CONSUMABLE">
                    <!-- 2699 Temporary change for pay-as-you-go total while pricing is being resolved -->
                    <!-- <div class="w-[69px] h-11 flex-col justify-start items-start gap-2 inline-flex">
                      <div class="self-stretch px-3 py-2.5 rounded-xl box-border border border-[#52B4FF]/20 justify-start items-center gap-2 inline-flex overflow-hidden bg-white/3 hover:bg-white/5 duration-160">
                        
                        <div class="grow shrink basis-0 h-6 justify-center items-center gap-2 flex">
                           recomment out <div class="grow shrink basis-0 text-right text-white/90 text-base font-semibold font-['Inter'] leading-normal">1</div> 
                            <input
                              @keydown="preventInvalidNumberInput"
                              @input="preventDecimalInput"
                              @paste="preventDecimalPaste"
                              min="1"
                              step="1"
                              type="number"
                              class="grow shrink basis-0 text-right text-white/90 text-base font-semibold font-['Inter'] leading-normal w-[40px] outline-none"
                              v-model="payAsYouGoUsers"
                              data-testid="pay-as-you-go-hours-input"
                            />
                        </div> 
                      </div>
                    </div>-->
                    <div class="self-stretch pt-0.5 justify-center items-center gap-2 flex">
                      <!-- <div class="text-white/90 text-sm font-normal font-['Inter'] leading-tight">{{ $t('plans_hours') }}</div> -->
                    </div>
                    <div class="w-[146px] self-stretch py-2.5 flex-col justify-start items-start gap-2 inline-flex">
                      <div class="self-stretch grow shrink basis-0 flex-col justify-start items-start gap-4 flex">
                        <!-- 2699 Temporary change for pay-as-you-go total while pricing is being resolved -->
                        <!-- <div class="self-stretch text-right text-white text-base font-semibold font-['Inter'] leading-normal" data-testid="pay-as-you-go-total">{{ $t('plans_total') }}: ${{ payAsYouGoUsers * Number(getHourlyPrice(plan)) }}</div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </PricingCard>
          </div>
          <div v-if="plansFooterText" class="text-center text-white/75 text-sm font-medium font-['Inter'] leading-tight flex justify-center w-full mt-[24px] pb-[40px] md:pb-0" data-testid="plans-footer">
            <div class="max-w-[1040px]" data-testid="plans-footer-text">
              {{ plansFooterText }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <main-footer></main-footer>
</template>

<script>
/* eslint-disable */
// @ is an alias to /src
import Toggle from '@vueform/toggle'
import ProductService from "@/services/products.service";
import {mapGetters, mapMutations, mapState} from 'vuex';
import axios from "axios";
import { PlanType, BillingType } from "@/constants/pricing-page"
import { Constants } from '@/cfg/constants'
import { useLDFlag } from 'launchdarkly-vue-client-sdk'
import PricingCard from '@/components/ui/PricingCard.vue';
import MainFooter from '@/components/MainFooter.vue';
import emitter from "@/services/emitter.service";
import checkIcon from '@/assets/icons/sorenson/check.svg';
import clockIcon from '@/assets/icons/sorenson/clock.svg';
import usersIcon from '@/assets/icons/sorenson/users.svg';

const CURRENCY_SYMBOLS = Object.freeze({
  GBP: '£',
  USD: '$',
});

const DISPLAY_PAYMENT_TYPE_PRIORITY = Object.freeze(['stripe', 'invoice_pricing']);
const ENTERPRISE_PAYMENT_TYPE_PRIORITY = Object.freeze(['manual', 'stripe', 'invoice_pricing']);
const ENTERPRISE_PLAN_ID = 'enterprise';
const FEATURE_ICONS = Object.freeze({
  check: checkIcon,
  clock: clockIcon,
  users: usersIcon,
});

export default {
    name: 'AboutView',
    components: {
        Toggle,
        PricingCard,
        MainFooter
    },
    setup() {
        // Env values are the fallback until LaunchDarkly responds (or when it is not configured).
        return {
            purchaseEnabled: useLDFlag('purchase-enabled', Constants.PURCHASE_ENABLED),
            showPrices: useLDFlag('show-prices', Constants.SHOW_PRICES),
        };
    },
    data() {
        return {
            yearly: true, // as per discussion, all plans will be yearly
            yearlyEnabled: true, // as per discussion, all plans will be yearly for now
            products: {},
            displayProducts: [],
            tiers: {
                'basic': 0,
                'starter': 1,
                'professional': 2,
                'premium': 3
            },
            plansDirections: {},
            payAsYouGoUsers: 1,
            isFetching: true,
            PlanType,
            BillingType,
            DummyPlanType: 'sorenson_professional_buy_more_hours',
            planViewCampaignName: ""
        }
    },
    methods: {
        openBeacon() {
            window.Beacon('open');
        },
        isEnterprisePlan(plan) {
          const id = typeof plan === 'string' ? plan : plan?.id;
          const subscriptionKey = typeof plan === 'string' ? plan : plan?.subscription_key;

          return id === ENTERPRISE_PLAN_ID || subscriptionKey === ENTERPRISE_PLAN_ID;
        },
        createFallbackEnterprisePlan() {
          return {
            id: ENTERPRISE_PLAN_ID,
            subscription_key: ENTERPRISE_PLAN_ID,
            title: this.$t('plans_enterprise_title'),
            description: this.$t('plans_enterprise_description'),
            status: 'active',
            ui_visibility: true,
            is_custom: false,
            is_recommended: false,
            billing: {
              type: this.BillingType.SUBSCRIPTION,
              is_paid: true,
            },
            features: {
              multiple_events: {
                allowed: true,
                icon: 'users',
                label_key: 'plans_enterprise_features_multiple_events',
              },
              tailored_plan: {
                allowed: true,
                icon: 'check',
                label_key: 'plans_enterprise_features_tailored_plan',
              },
              permanent_room_codes: {
                allowed: true,
                icon: 'check',
                label_key: 'plans_enterprise_features_permanent_room_codes',
              },
            },
            payment_types: {},
          };
        },
        getPlanTitle(plan) {
          if (this.isEnterprisePlan(plan) && this.isEnterpriseUser && this.user?.subscription?.title) {
            return this.user.subscription.title;
          }

          return plan.title;
        },
        isCurrentPlan(plan) {
          return this.userCurrentPlan === plan.id || (this.isEnterprisePlan(plan) && this.isEnterpriseUser);
        },
        appendBeforeEnterprise(plans, planToAppend) {
          const enterpriseIndex = plans.findIndex((plan) => this.isEnterprisePlan(plan));

          if (enterpriseIndex === -1) {
            plans.push(planToAppend);
            return plans;
          }

          plans.splice(enterpriseIndex, 0, planToAppend);
          return plans;
        },
        isHostEventAllowed(plan) {
          return Boolean(plan?.features?.host_event?.allowed);
        },
        getHostEventParticipants(plan) {
          return plan?.features?.host_event?.participants_per_event || 0;
        },
        hasTranslationTimeFeature(plan) {
          return Number(plan?.features?.asr?.total_allowed_items) > 0;
        },
        hasFullAccessTranslationFeature(plan) {
          return Boolean(
            plan?.features?.asr?.allowed &&
            plan?.features?.asr?.real_time_translation &&
            plan?.features?.closed_captioning?.allowed
          );
        },
        getFeatureIcon(iconName) {
          return FEATURE_ICONS[iconName] || FEATURE_ICONS.check;
        },
        getFeatureText(feature) {
          if (feature.label_key) {
            return this.$t(feature.label_key, feature.params || {});
          }

          return feature.text || feature.label || '';
        },
        getConfiguredFeatureItems(plan) {
          return Object.entries(plan?.features || {}).reduce((items, [key, feature]) => {
            if (!feature || feature.allowed === false) {
              return items;
            }

            const text = this.getFeatureText(feature);
            if (!text) {
              return items;
            }

            const iconName = feature.icon || 'check';
            items.push({
              key,
              icon: this.getFeatureIcon(iconName),
              iconAlt: iconName,
              text,
            });

            return items;
          }, []);
        },
        getPlanFeatureItems(plan) {
          const items = this.getConfiguredFeatureItems(plan);

          if (plan.id === this.DummyPlanType) {
            items.push({
              key: 'hours-validity',
              icon: this.getFeatureIcon('users'),
              iconAlt: 'users',
              text: this.$t('plans_hours_validity'),
            });
          } else if (this.isHostEventAllowed(plan)) {
            items.push({
              key: 'host-event',
              icon: this.getFeatureIcon('users'),
              iconAlt: 'users',
              text: `${this.$t('plans_one_event')} ${this.getHostEventParticipants(plan)} ${this.$t('plans_participants')}`,
            });
          }

          if (this.hasTranslationTimeFeature(plan)) {
            items.push({
              key: 'translation-time',
              icon: this.getFeatureIcon('clock'),
              iconAlt: 'clock',
              text: `${this.$t('plans_up_to')} ${this.getPlanHourText(plan)} ${this.$t('plans_free_trial_translation_time')}`,
            });
          }

          if (this.hasFullAccessTranslationFeature(plan)) {
            items.push({
              key: 'full-access-translation',
              icon: this.getFeatureIcon('check'),
              iconAlt: 'check',
              text: this.$t('plans_full_access_translation'),
            });
          }

          if (
            plan.id === this.PlanType.SORENSON_PROFESSIONAL &&
            !this.hasTranslationTimeFeature(plan) &&
            this.hasYearlyTotalHours(plan)
          ) {
            items.push({
              key: 'yearly-total-hours',
              icon: this.getFeatureIcon('clock'),
              iconAlt: 'clock',
              text: `${this.getYearlyTotalHours(plan)} ${this.$t('plans_hours_of_event_time_annually')}`,
            });
          }

          return items;
        },
        preventInvalidNumberInput(event) {
          const keyCode = event.keyCode || event.which;
          if (['e', '+', '-', '.', 'E'].includes(event.key) || keyCode === 46) {
              event.preventDefault();
          }
        },
        preventDecimalInput(event) {
          const value = event.target.value;
          if (value.includes('.')) {
            event.target.value = value.replace(/\./g, '');
            this.payAsYouGoUsers = parseInt(event.target.value, 10);
          }
        },
        preventDecimalPaste(event) {
          const paste = (event.clipboardData || window.clipboardData).getData('text');
          if (paste.includes('.')) {
            event.preventDefault();
          }
        },
        getPlans() {
            this.isFetching = true;
            this.products = {};
            this.displayProducts = [];
            ProductService.getProductsArray().then((data) => {
                const subscriptions = data.data.result.subscriptions || [];
                const prePlans = subscriptions.filter((pr) => {
                    return pr.ui_visibility && !pr.is_custom
                });

                if (!subscriptions.some((plan) => this.isEnterprisePlan(plan))) {
                  prePlans.push(this.createFallbackEnterprisePlan());
                }

                subscriptions.forEach((subscription) => {
                  this.products[subscription.id] = subscription;
                });

                prePlans.forEach((plan) => {
                  this.products[plan.id] = this.products[plan.id] || plan;
                });

                this.displayProducts = prePlans;
              }).finally(() => {
                this.isFetching = false;
                const query = this.$route.query;
                if (query && query.go === 'checkout' && this.getPurchasingPlan) {
                  if(this.getPurchasingPlan) {
                    const selectedPlan = this.getPurchasingPlan;
                    this.selectPlan(selectedPlan);
                    this.$store.commit("auth/setPurchasingPlan", "");
                  }
                }
              });
        },
        getPlansDirections() {
            axios.get('/data/plans-directions.json').then((response) => {
                this.plansDirections = response.data;
            });
        },
        selectPlan(planOrCode) {
          const code = typeof planOrCode === 'string' ? planOrCode : planOrCode?.id;

          if (this.isEnterprisePlan(planOrCode)) {
            this.openBeacon();
            return;
          }

          const purchaseType = this.getPurchaseType(code);
          const product = this.getCheckoutProduct(code);
          const selectedPlan = typeof planOrCode === 'string' ? product : planOrCode;

          if (!this.authorized) {
            if (this.isContactSalesPlan(selectedPlan) || this.isContactSalesPlan(product)) {
              this.openBeacon();
              return;
            }

            this.$store.commit('auth/setPurchasingPlan', code);
            this.$store.commit('auth/setPurchaseType', purchaseType);
            emitter.emit('open-auth0');
            return;
          }

          if (code === this.PlanType.SORENSON_FREE_TRIAL) {
            if (this.PlanType.SORENSON_FREE_TRIAL === this.userCurrentPlan) {
              this.redirectToCurrentPlan();
            } else {
              ProductService.requestTrial(this.PlanType.SORENSON_FREE_TRIAL)
                  .then(() => {
                    this.$dialog.alert("success_requested_trial", {
                      icon: "success"
                    }).then(() => emitter.emit('open-subscription-popup'))
                  })
                  .catch((error) => {
                    this.$toast.error(error.response.data.error)
                  })
            }
            return;
          } else if(code === this.userCurrentPlan &&
              this.userCurrentPlan !== this.PlanType.SORENSON_CONSUMABLE) {
            this.redirectToCurrentPlan();
            return;
          }

          if (this.isContactSalesPlan(selectedPlan) || this.isContactSalesPlan(product)) {
            this.openBeacon();
            return;
          }

          if (
            this.user?.subscription?.payment_type?.length > 0 &&
            this.isMobileUser &&
            this.user.subscription.type !== this.PlanType.SORENSON_FREE_TRIAL
          ) {
            this.$toast.error('apple_subscription_notice')
            return false;
          }

          const price = this.getCheckoutPrice(product, purchaseType);

          if (!price?.id) {
            this.$toast.error('plan_price_unavailable');
            return;
          }

          this.$store.commit('auth/setPurchaseType', purchaseType);
          this.$store.commit("auth/setPriceId", price.id);

          if (purchaseType === 'consumable') {
            ProductService.onetimeBuy(this.token, price.id, this.payAsYouGoUsers)
                .then((data) => {
                  let result = data.data.result;
                  location.href = result.url
                })
                .catch((error) => {
                  this.$toast.error(error.response.data.error)
                })
            return;
          }

          ProductService.createOrder(this.token, price.id).then((data) => {
            let result = data.data.result;
            location.href = result.url
          })
          .catch((error) => {
            this.$toast.error(error.response.data.error)
          })
        },
        getPurchaseType(code) {
          return code === this.PlanType.SORENSON_CONSUMABLE || code === this.DummyPlanType ? 'consumable' : 'plan';
        },
        getCheckoutProduct(code) {
          if (code === this.DummyPlanType) {
            return this.products[this.userCurrentPlan] || this.products[this.PlanType.SORENSON_PROFESSIONAL];
          }

          return this.products[code];
        },
        isInvoicePurchasePlan(plan) {
          if (plan?.billing?.purchase_flow === 'invoice') {
            return true;
          }

          const paymentTypes = Object.keys(plan?.payment_types || {});
          return paymentTypes.length > 0 && paymentTypes.every((paymentType) => paymentType === 'invoice_pricing');
        },
        isContactSalesPlan(plan) {
          return Boolean(plan) && (
            this.isEnterprisePlan(plan) ||
            this.isInvoicePurchasePlan(plan) ||
            this.isPurchaseDisabledPlan(plan)
          );
        },
        getCheckoutPrice(item, purchaseType) {
          if (purchaseType === 'consumable') {
            return this.getStripePrice(item, 'hourly');
          }

          if (this.yearly && this.hasStripePrice(item, 'yearly')) {
            return this.getStripePrice(item, 'yearly');
          }

          return this.getStripePrice(item, 'monthly') || this.getStripePrice(item, 'yearly');
        },
        getPaymentPrice(item, paymentType, period) {
          const price = item?.payment_types?.[paymentType]?.prices?.[period];
          const amount = Number(price?.price);

          if (!Number.isFinite(amount)) {
            return null;
          }

          return {
            ...price,
            price: amount,
          };
        },
        getFirstAvailablePaymentPrice(item, paymentTypes, period) {
          for (const paymentType of paymentTypes) {
            const price = this.getPaymentPrice(item, paymentType, period);

            if (price) {
              return price;
            }
          }

          return null;
        },
        getFirstAvailablePaymentPriceForPeriods(item, paymentTypes, periods) {
          for (const paymentType of paymentTypes) {
            for (const period of periods) {
              const price = this.getPaymentPrice(item, paymentType, period);

              if (price) {
                return {
                  period,
                  price,
                };
              }
            }
          }

          return null;
        },
        getDisplayPaymentTypes(plan) {
          return this.isEnterprisePlan(plan) ? ENTERPRISE_PAYMENT_TYPE_PRIORITY : DISPLAY_PAYMENT_TYPE_PRIORITY;
        },
        getPricingProduct(plan) {
          if (this.isEnterprisePlan(plan) && this.isEnterpriseUser && this.products[this.userCurrentPlan]) {
            return this.products[this.userCurrentPlan];
          }

          return plan;
        },
        getDisplayPrice(item, period, paymentTypes = DISPLAY_PAYMENT_TYPE_PRIORITY) {
          return this.getFirstAvailablePaymentPrice(item, paymentTypes, period);
        },
        hasDisplayPrice(item, period, paymentTypes = DISPLAY_PAYMENT_TYPE_PRIORITY) {
          return Boolean(this.getDisplayPrice(item, period, paymentTypes));
        },
        getStripePrice(item, period) {
          return this.getPaymentPrice(item, 'stripe', period);
        },
        hasStripePrice(item, period) {
          return Boolean(this.getStripePrice(item, period));
        },
        hasYearlyTotalHours(item) {
          const pricingProduct = this.getPricingProduct(item);
          const paymentTypes = this.getDisplayPaymentTypes(item);
          const yearlyPrice = this.getDisplayPrice(pricingProduct, 'yearly', paymentTypes)?.price;
          const hourlyPrice = this.getDisplayPrice(pricingProduct, 'hourly', paymentTypes)?.price;

          return Number.isFinite(yearlyPrice) && Number.isFinite(hourlyPrice) && hourlyPrice > 0;
        },
        formatPrice(price) {
          const amount = Number(price);

          if (!Number.isFinite(amount)) {
            return '';
          }

          return (amount / 100).toFixed(0);
        },
        getDiscountFromText(item, period = 'hourly') {
            const pricingProduct = this.getPricingProduct(item);
            const paymentTypes = this.getDisplayPaymentTypes(item);
            const price = this.getDisplayPrice(pricingProduct, period, paymentTypes);

            if (!price?.discount || pricingProduct?.billing?.type !== this.BillingType.CONSUMABLE) {
                return null;
            }

            return `${this.currencySymbol}${this.formatPrice(price.price / (1 - price.discount / 100))}`;
        },
        getYearlyTotalHours(item) {
          const pricingProduct = this.getPricingProduct(item);
          const paymentTypes = this.getDisplayPaymentTypes(item);
          const yearlyPrice = this.getDisplayPrice(pricingProduct, 'yearly', paymentTypes)?.price;
          const hourlyPrice = this.getDisplayPrice(pricingProduct, 'hourly', paymentTypes)?.price;

          if (!Number.isFinite(yearlyPrice) || !Number.isFinite(hourlyPrice) || hourlyPrice <= 0) {
            return '';
          }

          return `${+((yearlyPrice / hourlyPrice).toFixed(0))}`;
        },
        getHourlyPrice(item) {
            const pricingProduct = this.getPricingProduct(item);
            const paymentTypes = this.getDisplayPaymentTypes(item);
            const hourlyPrice = this.getDisplayPrice(pricingProduct, 'hourly', paymentTypes)?.price;

            if (!Number.isFinite(hourlyPrice)) {
              return '';
            }

            return this.formatPrice(hourlyPrice);
        },
        getPlanHourText(item) {
          const hours = item.features?.asr?.total_allowed_items / 3600;
          return  `${hours} ${hours == 1 ? this.$t('plans_hour') : this.$t('plans_hours')}`;
        },
        getYearlyPrice(item) {
          const pricingProduct = this.getPricingProduct(item);
          const paymentTypes = this.getDisplayPaymentTypes(item);
          return this.formatPrice(this.getDisplayPrice(pricingProduct, 'yearly', paymentTypes)?.price);
        },
        getMonthlyPrice(item) {
          const pricingProduct = this.getPricingProduct(item);
          const paymentTypes = this.getDisplayPaymentTypes(item);
          return this.formatPrice(this.getDisplayPrice(pricingProduct, 'monthly', paymentTypes)?.price);
        },
        isPurchaseDisabledPlan(plan) {
          return !this.purchaseEnabled && Boolean(plan);
        },
        isPlanButtonDisabled(plan) {
          return this.authorized && plan.id === this.PlanType.SORENSON_FREE_TRIAL && !this.isUserFreeTrialHoursAvailable;
        },
        scrollToPricingCards() {
            document.getElementById('pricing-cards').scrollIntoView({behavior: 'smooth'});
        },
        redirectToCurrentPlan() {
            emitter.emit('open-subscription-popup');
        },
        isConsumable(product) {
          return product.billing.type === this.BillingType.CONSUMABLE;
        },
        getPlanButtonText(plan) {
          if (this.isEnterprisePlan(plan)) {
            return this.$t('plans_enterprise_button_text');
          }

          if (this.authorized) {
            if (
              plan.id === this.userCurrentPlan &&
                plan.id !== this.PlanType.SORENSON_CONSUMABLE &&
              (this.userCurrentPlan !== this.PlanType.BASIC || this.isUserFreeTrialHoursAvailable)
            ) {
              return this.$t('plans_view_my_plan');
            } else if (plan.id === this.PlanType.SORENSON_FREE_TRIAL && !this.isUserFreeTrialHoursAvailable) {
              return this.$t('plans_trial_expired');
            } else if (this.isContactSalesPlan(plan)) {
              return this.$t('plans_enterprise_button_text');
            } else if (plan.billing?.type === this.BillingType.ONETIME) {
              return this.$t('plans_try_now');
            } else if (plan.billing?.type === this.BillingType.CONSUMABLE) {
              return this.$t('plans_purchase_hours');
            } else {
              return this.$t('plans_subscribe_now');
            }
          } else {
            if (this.isContactSalesPlan(plan)) {
              return this.$t('plans_enterprise_button_text');
            }

            return plan.billing?.type === this.BillingType.ONETIME
              ? this.$t('plans_try_now')
              : plan.billing?.type === this.BillingType.CONSUMABLE
              ? this.$t('plans_purchase_hours')
              : this.$t('plans_subscribe_now');
          }
        },
        getPriceText(plan) {
          const pricingProduct = this.getPricingProduct(plan);
          const paymentTypes = this.getDisplayPaymentTypes(plan);

          const fixedPeriodPrice = this.getFirstAvailablePaymentPriceForPeriods(
            pricingProduct,
            paymentTypes,
            ['yearly', 'monthly']
          );

          if (!fixedPeriodPrice && pricingProduct?.billing?.type === this.BillingType.CONSUMABLE) {
            return this.hasDisplayPrice(pricingProduct, 'hourly', paymentTypes) ? `${this.currencySymbol}${this.getHourlyPrice(plan)} ${this.$t('plans_per_hour')}` : '';
          }

          if (!fixedPeriodPrice) {
            return '';
          }

          const label = fixedPeriodPrice.period === 'monthly'
            ? this.$t('plans_monthly_subscription')
            : this.$t('plans_annual_subscription');

          return `${label}: ${this.currencySymbol}${this.formatPrice(fixedPeriodPrice.price.price)}`;
        },
    },
    computed: {
        ...mapState('auth', ['token', 'authorized', 'campaign_name']),
        ...mapState('nonpersist', ['user']),
        ...mapGetters('auth', ['getPurchasingPlan']),
        userCurrentPlan() {
            if (!this.authorized) {
                return false;
            }

            if (this.user && this.user.subscription) {
                return this.user.subscription.type;
            }
        },
        plansFooterTranslationKey() {
          const footerKey = Constants.REGION === 'uk' ? 'uk_plans_v0_footer' : 'plans_v0_footer';

          return this.$te(footerKey) ? footerKey : '';
        },
        plansFooterText() {
          return this.plansFooterTranslationKey ? this.$t(this.plansFooterTranslationKey) : '';
        },
        currency() {
          return Constants.REGION_CONFIG.currency;
        },
        currencySymbol() {
          return CURRENCY_SYMBOLS[this.currency] || '$';
        },
        isCurrentAnnual() {
            return this.user?.subscription?.billing_frequency === 'yearly';
        },
        isUserFreeTrialHoursAvailable() {
            if (this.userCurrentPlan !== this.PlanType.SORENSON_FREE_TRIAL) {
                return true;
            }
            return this.user.features?.asr?.allowed && this.user.features?.asr?.left_allowed_items > 0;
        },
        isEnterpriseUser() {
            // Ensure data dependencies are defined and valid before evaluating
            const hasAuthorized = this.authorized !== undefined && this.authorized !== null;
            const hasPlanType = Array.isArray(Object.values(this.PlanType)) && this.PlanType !== undefined;
            const hasSubscriptionType = this.user && this.user.subscription && this.user.subscription.type;
            return hasAuthorized && hasPlanType && hasSubscriptionType && !Object.values(this.PlanType).includes(this.user.subscription.type);
        },
        isMobileUser() {
            return this.user.subscription.payment_type !== 'stripe' && this.user.subscription.payment_type !== 'manual';
        },
        displayProductsModified() {
          if (!this.authorized || this.userCurrentPlan !== this.PlanType.SORENSON_PROFESSIONAL || this.isEnterpriseUser) {
            return this.displayProducts;
          }
          if (!this.isFetching) {
            // Remove the Pay-as-you-go consumable
            const newlyComputedPlans = this.displayProducts.filter((plan) => plan.billing?.type !== this.BillingType.CONSUMABLE);
            const professionalPlan = this.products[this.PlanType.SORENSON_PROFESSIONAL];

            if (!professionalPlan) {
              return newlyComputedPlans;
            }

            // Add the "Buy more hours" consumable for the Professional plan
            this.appendBeforeEnterprise(newlyComputedPlans, {
              ...professionalPlan,
              // TODO: identify the correct id for the plan Professional(consumable)
              id: this.DummyPlanType,
              title: "Buy more hours",
              description: "Pay only for what you need",
              billing: {
                ...professionalPlan.billing,
                type: this.BillingType.CONSUMABLE,
              },
            });
            return newlyComputedPlans;
          }
          return []
        },
        pricingCardsGridClass() {
          return this.displayProductsModified.length >= 4 ? 'xl:grid-cols-4' : 'xl:grid-cols-3';
        }
    },
    async mounted() {
      console.log("Route Parameters: ", this.$route.params);
      this.planViewCampaignName = this.$route.params.campaign_name;
      console.log("The Campaign Name is: ", this.planViewCampaignName);
      this.yearlyEnabled = true;
      await this.getPlans();
      await this.getPlansDirections();
      
      console.log("Campaign Name is: ", this.planViewCampaignName);
      if (this.planViewCampaignName) {
        try {
          // save to the Vuex store
          console.log("Attempting to store using auth/storeCampaignDataLocally");
          await this.$store.dispatch('auth/storeCampaignDataLocally', this.planViewCampaignName);
          console.log("Updated state of campaign_name: ", this.campaign_name);
          // save to localStorage  // reason for local store:   //TODO:  review needing this and remove if not needed
          localStorage.setItem('campaign_name', this.planViewCampaignName);
          // check if authorized
          if(this.authorized) {
            // user is authenticated, save to backend
            // note:  this endpoint needs the following params:
            // token
            // name - in this case the name is "campaign_name"
            // value - the campaignName string
            this.user.name = "campaign_name";
            this.user.value = this.planViewCampaignName;
            this.user.token = this.token;
            console.log("Payload before API call: ", this.user);
            this.$store.dispatch("auth/saveCampaignDataToBackend", this.user).then(
              () => {
                console.log("Campaign Data Saved to Backend");
                // NOTE:  campaign redirect happens in auth.module.js if successful
              },
              (error) => {
                this.$toast.error(error.response.data.error);
              }
            );
          }
        } catch (error) {
          console.error('Failed to store campaign_name: ', error);0
        }
      }

      emitter.on('pricing-page-on-signed-in', () => {
        if(this.getPurchasingPlan) {
          const selectedPlan = this.getPurchasingPlan;
          this.selectPlan(selectedPlan);
          this.$store.commit("auth/setPurchasingPlan", "");
        }
      });
    }
}
</script>

<style lang="scss" scoped>
html, body, #app {
    min-height: 100% !important;
    height: auto !important;
}

.bg-hero-image {
  background-image: url('@/assets/media/pricing-hero-image.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 100%;
  width: 100%; 
}

.page-wrapper {

    &--plans {
        /* justify-content: center; */
        align-items: center;
        width: 100%;
        margin: 0 auto;
        padding-top: 0rem;
    }
}

.pricing {
    width: 100%;

    &-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 2rem;

        &__left {
            font-size: 1.25rem;
            line-height: 100%;
            font-weight: 400;
            color: #979797;
            display: flex;
            align-items: center;
        }

        &__right {
            font-weight: 400;
            font-size: 1.375rem;
            line-height: 150%;
            color: #3D485A;
            display: flex;

            .toggle-container {
                margin: 0 1rem;
            }
        }
    }

    &-table {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        column-gap: 11px;

        &.pricing-table--3col {
            grid-template-columns: 1fr 1fr 1fr;
        }
    }

    .plan-column {

        .plan {
            background: linear-gradient(0.78deg, #F0F0F0 3.95%, rgba(252, 251, 252, 0) 97.57%);
            border: 3px solid #DADADA;
            border-radius: 10px;
            padding: 3rem 2.5rem 0;
            height: 100%;
            font-size: 1rem;
            line-height: 120%;

                &--highlighted {
                    background: linear-gradient(180deg, #6CBFFF 0%, #A5771A 100%);
                    /* Forum shadow */

                box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                color: #fff;
                border: none;
                height: 104%;
                position: relative;
                top: -2%;

                .highlight-text {
                    color: #FAFAFA;
                    opacity: 0.5;
                    font-size: 1.25rem;
                    line-height: 150%;
                    margin-bottom: 1px;
                }

                & + .subscribe-btn {
                    position: relative;
                    top: -2%;
                }
            }

            .asterisked {
                font-size: 0.6rem;
                line-height: 120%;
            }

            &__title {
                height: 5rem;

                h2 {
                    font-weight: 700;
                    font-size: 1.6rem;
                    line-height: 150%;
                    margin: 0 0 2px 0;
                }
            }

            &__price {
                font-size: 1.25rem;
                line-height: 150%;
                font-weight: 700;
                margin-bottom: 2rem;

                b {
                    font-size: 2.25rem;
                    line-height: 100%;
                }

                &--year-monthly {
                    margin-top: -20px;
                    color: #979797;

                    b {
                        font-size: 1.5rem;
                    }
                }
            }

            &__features {
                margin-top: 2rem;

                ul {
                    margin: 0;
                    padding: 0;
                    list-style: none;

                    li {
                        margin-top: 18px;

                        &:first-child {
                            margin-top: 0;
                        }

                        .inline-block {
                            position: static;
                            padding-left: 5px;
                            padding-top: 2px;

                            img {
                                vertical-align: bottom;
                                position: relative;
                                top: -2px;
                            }
                        }
                    }
                }
            }

            &.plan--custom {
                display: flex;
                flex-direction: column;

                .plan__price {
                    margin-bottom: 0;
                }

                .plan__custom-content {
                    margin: auto;
                    display: flex;
                    flex-direction: column;
                    flex: 1;
                    height: 100%;
                    align-items: center;
                    justify-content: center;

                    p {
                        font-size: 1.7rem;
                        line-height: 110%;
                        text-align: center;
                        margin-top: 0;
                    }

                    a {
                      font-weight: 700;
                      font-size: 1.6rem;
                      display: flex;
                      align-items: center;
                      text-align: center;
                      -webkit-text-decoration-line: underline;
                      text-decoration-line: underline;
                      color: #6CBFFF;
                    }
                }

                  .custom-question {
                        font-size: 10rem;
                        line-height: 75%;
                        color: #6CBFFF;
                  }
                }
            }

            &:hover {
                .plan {
                    border-color: #6CBFFF;
                }   
            }
        }

    .buttons-row {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        column-gap: 11px;

            .button-column {
                padding: 0 1.5rem 0;
            }
        }
        .subscribe-btn {
            background: #6CBFFF;
            border-radius: 25px;
            color: #fff;
            text-transform: uppercase;
            font-size: 1rem;
            line-height: 1.2rem;
            display: flex;
            align-items: center;
            text-align: center;
            letter-spacing: 0.15em;
            height: 2.8rem;
            justify-content: center;
            font-weight: 700;
            margin: 11px auto 0;
            width: 80%;

        &:hover {
            filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
        }

        &--margined {
            margin-top: 25px;
        }
    }

    .current-selected {
        text-transform: uppercase;
        font-size: 1rem;
        line-height: 1.2rem;
        display: flex;
        align-items: center;
        text-align: center;
        letter-spacing: 0.15em;
        height: 2.8rem;
        justify-content: center;
        font-weight: 700;
        margin: 11px auto 0;
        width: 80%;

        &.current-selected--downgrade {
            text-transform: none;
            /* line-height: 1rem; */
            letter-spacing: 0.1em;
            width: 90%;
        }
    }

    &-footer {
        display: flex;
        justify-content: center;
        font-weight: 400;
        font-size: 1.6rem;
        line-height: 120%;
        /* identical to box height, or 30px */

        display: flex;
        align-items: center;
        text-align: center;
        font-feature-settings: 'pnum' on, 'lnum' on;

        color: #979797;
        margin-top: 6rem;
        padding-bottom: 2.25rem;
        flex-direction: column;

        a {
            font-weight: 700;
            font-size: 1.6rem;
            /* identical to box height, or 38px */

            display: flex;
            align-items: center;
            text-align: center;
            text-decoration-line: underline;

            /* Gold */

                color: #6CBFFF;
                margin-left: 1rem;
            }
        }
    }
    :deep(.popper) {
        max-width: 200px !important;
        text-align: left !important;
        font-size: 0.8rem !important;
        line-height: 150% !important;
        font-weight: 400;
        padding: 1rem;
    }

.tabs-controls {
    margin-bottom: 30px;
    display: flex;
    column-gap: 2.25rem;

    a {
        color: #000;
        font-weight: 700;
        font-size: 2.25rem;
        line-height: 100%;
        padding-bottom: 10px;
        border-bottom: 2px solid transparent;

        &.active {
          color: #6CBFFF;
          border-color: #6CBFFF;
        }
    }
}

.tabs-controls__subheader {

    margin-bottom: 30px;
    font-size: 1.25rem;
    line-height: 125%;
    width: 90%;

}

    .contact-link {
      font-weight: 700;
      font-size: 1.6rem;
      display: flex;
      align-items: center;
      text-align: center;
      -webkit-text-decoration-line: underline;
      text-decoration-line: underline;
      color: #6CBFFF;
      justify-content: center;
      margin-top: 1rem;
    }

input[type=number] {
    -moz-appearance: textfield;
    appearance: textfield;
    margin: 0;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
</style>
